import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";

import {CardContainer, Button} from 'components/common/uiKit';

import * as RouteService from 'services/route';

class PaymentResult extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            type: '',
            tid: '',
            message: ''
        };
    }

    componentDidMount() {
        const qs = RouteService.QueryStringService.getQyeryStrings();

        if (qs && qs.type) {
            this.setState({type: qs.type, tid: qs.tid, message: qs.message});
        }
    }

    _handleSubmit = () => {
        const {history} = this.props;
        history.push({
            pathname: '/app'
        })
    };

    render() {
        const {type, tid, message} = this.state;

        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.App.PaymentResult;

        if (!type)
            return (
                <CardContainer>
                    <div className='text-center'>
                        <i className='fa fa-spinner text-warning font-40 font-900'/>
                        <h3 className='text-warning text-center mt-4'>
                            {pageTranslates.Loading}
                        </h3>
                    </div>
                </CardContainer>
            );

        switch (type) {
            case 'success':
                return (
                    <CardContainer>
                        <div className='text-center'>
                            <i className='fa fa-check-circle text-success font-40 font-900'/>
                            <h2 className='text-success text-center mt-4'>
                                {pageTranslates.SucceedPayment}
                            </h2>
                            <h6 className='text-center mt-2'>
                                {pageTranslates.TrackingCode}: {tid}
                            </h6>
                            <Button title={pageTranslates.Return} classes='mt-4' full type='primary' shadowType='xl'
                                    onClick={this._handleSubmit}/>
                        </div>
                    </CardContainer>
                );
            case 'warning':
                return (
                    <CardContainer>
                        <div className='text-center'>
                            <i className='fa fa-times-circle text-danger font-40 font-900'/>
                            <h2 className='text-danger text-center mt-4'>
                                {pageTranslates.UnSucceedPayment}
                            </h2>
                            <h6 className='text-center mt-2'>
                                {message}
                            </h6>
                            <Button title={pageTranslates.Return} classes='mt-4' full type='primary' shadowType='xl'
                                    onClick={this._handleSubmit}/>
                        </div>
                    </CardContainer>
                );
            case 'error':
                return (
                    <CardContainer>
                        <div className='text-center'>
                            <i className='fa fa-times-circle text-danger font-40 font-900'/>
                            <h2 className='text-danger text-center mt-4'>
                                {pageTranslates.UnSucceedPayment}
                            </h2>
                            <h6 className='text-center mt-2'>
                                {pageTranslates.ContactUs}
                            </h6>
                            <Button title={pageTranslates.Return} classes='mt-4' full type='primary' shadowType='xl'
                                    onClick={this._handleSubmit}/>
                        </div>
                    </CardContainer>
                );
        }
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(withRouter(PaymentResult));